import { useObjectTypeSelect } from '../../hooks/useObjectTypeSelect';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { Select } from 'foundations-components/transitional/components/Select';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorObjectTypeSelect = () => {
  const {
    defaultValue,
    filteringObjectDropdownLabel,
    hasOnlyOneOption,
    itemComponent,
    options,
    value,
    onChange
  } = useObjectTypeSelect();
  return /*#__PURE__*/_jsx(View, {
    paddingBlockEnd: "200",
    as: "div",
    children: !hasOnlyOneOption && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(View, {
        marginBlock: "100",
        as: "div",
        children: /*#__PURE__*/_jsx(Small, {
          children: filteringObjectDropdownLabel || /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFiltersUI.objectTypeSelect.filteringOn.doublePanel"
          })
        })
      }), /*#__PURE__*/_jsx(Select, {
        defaultValue: defaultValue,
        itemComponent: itemComponent,
        onChange: onChange,
        options: options,
        value: value
      })]
    })
  });
};
export default EditorObjectTypeSelect;